import * as React from 'react';


const Popup = (props) => {
  const { children, onClose } = props;

  return (
    <div className="ol__cont">
      <a href="#" className="popup__overlay" onClick={onClose}/>
      <div className="popup__modal">
        {children}
      </div>
    </div>
  );
};

export default Popup;
